import React from 'react'
import { useSelector } from 'react-redux'

import TasksBoardView from 'pages/parts/tasks/TasksBoardView'

function Index() {
	const reduxAccount = useSelector(state => state.account)

	return (
		<TasksBoardView
			apiPrefix="/admin"
			categoriesPath="/admin/task-categories"
			currentUserLogin={reduxAccount?.login}
			canManageTask={() => true}
		/>
	)
}

export default Index
